import { IssueEntity } from 'serviceWorker/repository/issue/entity';
import {
  IssueChart,
  FilterValues,
  InspectionChart,
  ChartValuesAndLabels,
  ChartAxisSeries,
  TripletSeriesWithLabels,
} from 'shared/types/analytics';
import { createSeriesAndLabelsFromIssuesWithFilters as environmentalAspectCalculation } from './environmentalAspect';
import { createSeriesAndLabelsFromIssuesWithFilters as hsEffectCalculation } from './hsEffect';
import { createSeriesAndLabelsFromIssuesWithFilters as hsHazardTypeCalculation } from './hsHazardType';
import { createSeriesAndLabelsFromIssuesWithFilters as impactCalculation } from './impact';
import { createSeriesAndLabelsFromIssuesWithFilters as originatorCalculation } from './originator';
import { createSeriesAndLabelsFromIssuesWithFilters as rootCauseCalculation } from './rootCause';
import { createSeriesAndLabelsFromIssuesWithFilters as workTypeCalculation } from './workType';
import { createSeriesAndLabelsFromInspectionsWithFilters as completedInspectionsByTemplate } from './completedInspectionsByTemplate';
import { createSeriesAndLabelsFromInspectionsWithFilters as inspectionEvolution } from './inspectionEvolution';
import { createSeriesAndLabelsFromInspectionsWithFilters as inspectionTriplet } from './inspectionTriplet';
import { InspectionEntity } from 'serviceWorker/repository/inspection/entity';
import type { ChartAdditionalParams } from 'shared/domain/analytics/chartModel';

const chartCalculation = {
  [IssueChart.originator]: originatorCalculation,
  [IssueChart.rootCause]: rootCauseCalculation,
  [IssueChart.impact]: impactCalculation,
  [IssueChart.workType]: workTypeCalculation,
  [IssueChart.environmentalAspect]: environmentalAspectCalculation,
  [IssueChart.hsEffect]: hsEffectCalculation,
  [IssueChart.hsHazardType]: hsHazardTypeCalculation,
};

export function calculate(
  chart: IssueChart,
  issues: IssueEntity[],
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<ChartValuesAndLabels> {
  const calculation = chartCalculation[chart];
  if (!calculation) {
    return Promise.reject(new Error(`Unknown issue chart: ${chart}`));
  }
  return calculation(issues, filters, timezone, additionalParams);
}

const inspectionChartCalculation: Calculations = {
  [InspectionChart.completedInspectionsByTemplate]:
    completedInspectionsByTemplate,
  [InspectionChart.inspectionEvolution]: inspectionEvolution,
  [InspectionChart.inspectionTriplet]: inspectionTriplet,
};

type Calculations = Record<InspectionChart, CallableFunction>;

export function calculateInspections(
  chart: InspectionChart,
  inspections: InspectionEntity[],
  templateProcessByIdRecord: Record<string, { process: string }>,
  filters: FilterValues,
  timezone: string,
  additionalParams: ChartAdditionalParams | undefined
): Promise<
  ChartAxisSeries | ChartValuesAndLabels | TripletSeriesWithLabels
> {
  const calculation = inspectionChartCalculation[chart];
  if (!calculation) {
    return Promise.reject(new Error(`Unknown inspection chart: ${chart}`));
  }
  return calculation(
    inspections,
    templateProcessByIdRecord,
    // @ts-ignore in calculation we only care filters are of type FilterValues. I don't know yet how to handle this
    filters,
    timezone,
    additionalParams
  );
}
